import { AssessmentType } from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { getUiPreferenceCache } from "@apps/use-ui-preference-cache/use-ui-preference-cache";
import { currentOrganizationVar } from "@cache/cache";

import AssessmentQuestionStackedTextAnswers from "../assessment-question-stacked-text-answers";
import { AssessmentSidebarTab } from "../assessment/assessment-constants";
import { assessmentContextSidebarVar } from "../context-sidebar/context-sidebar-context";
import QuestionContextButton from "./question-context-button";
import TextAssessmentQuestionContent from "./text-assessment-question-content";
import { AssessmentAnswer } from "./types";

const TextQuestionForm = ({
  formDisabled,
  answer,
  onUpdateAnswer,
  questionId,
  responseItems,
  assessmentType,
}: {
  formDisabled: boolean;
  answer?: AssessmentAnswer | null;
  onUpdateAnswer: (newAnswer: Partial<AssessmentAnswer>) => void;
  questionId: number;
  responseItems: {
    responder?: BasicUser | null;
    text?: string | null;
  }[];
  assessmentType: AssessmentType;
}) => {
  const organization = currentOrganizationVar();
  return (
    <>
      <TextAssessmentQuestionContent
        disabled={formDisabled}
        answer={answer}
        onChangeAnswer={onUpdateAnswer}
        onFocus={() => {
          const uiPreferenceCache = getUiPreferenceCache();
          if (
            organization.featureFlags.reviewContextGeneration &&
            waffle.flag_is_active("review-context-sidebar") &&
            uiPreferenceCache.assessmentSidebarSelectedTab ===
              AssessmentSidebarTab.context
          ) {
            assessmentContextSidebarVar({
              questionId: questionId,
              showSuggestedResponses: true,
            });
          }
        }}
      />
      <QuestionContextButton
        questionId={questionId}
        assessmentType={assessmentType}
      />
      {responseItems.length > 0 &&
        assessmentType === AssessmentType.Performance && (
          <div className="mt-4">
            <AssessmentQuestionStackedTextAnswers
              questionId={questionId}
              answers={responseItems}
            />
          </div>
        )}
    </>
  );
};

export default TextQuestionForm;
